import React from "react";
import { ArrowLeft, X } from "lucide-react";
import ButtonV2 from "../../../components/ui/button/v2";
import { cn } from "../../../lib/utils";

interface AddEntitiesModalProps {
  title: string;
  children: React.ReactNode;

  onBack?: () => void;
  onClose: () => void;
  onDiscard: () => void;
  onSave: () => void;

  saveEnabled?: boolean;
  isSaving?: boolean;
  wide?: boolean;
}

export const AddEntitiesModal: React.FC<
  AddEntitiesModalProps
> = ({
  title,
  children,
  onBack,
  onClose,
  onDiscard,
  onSave,
  saveEnabled = true,
  isSaving,
  wide
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[rgba(10,10,10,0.20)]"   onClick={onClose}>
      <div className={cn("relative w-full rounded-[10px] border-[1px] border-[#E5E5E5] bg-white shadow-lg p-6", wide ? "max-w-[960px]" : "max-w-[425px]")} onClick={(e) => e.stopPropagation()}>

        <div className="flex items-center gap-2 pb-4">
          {onBack && (
            <button
              onClick={onBack}
              className="flex h-4 w-4 items-center justify-center text-[#737373]"
            >
              <ArrowLeft size={16} />
            </button>
          )}

          {wide && (
            <h2 className="text-[18px] font-semibold leading-none text-[#0A0A0A]">
              {title}
            </h2>
          )}

          <button
            onClick={onClose}
            className="absolute right-4 top-6 flex h-4 w-4 items-center justify-center"
          >
            <X size={16} className="relative -top-px text-[#0A0A0A] opacity-70" />
          </button>
        </div>

        <div className="flex flex-col gap-[14px]">
          {!wide && (
            <h2 className="text-[18px] font-semibold leading-none text-[#0A0A0A]">
              {title}
            </h2>
          )}

          {children}

          <div className={cn("flex gap-2", wide && "justify-end")}>
            <ButtonV2
              variant="secondary"
              onClick={onDiscard}
              disabled={isSaving}
              className={cn("rounded-[8px] border-[#3551F3] bg-[#EBEEFE] text-[#3551F3] ", wide ? "px-6" : "flex-1")}
            >
              Discard
            </ButtonV2>

            <ButtonV2
              variant="primary"
              onClick={onSave}
              disabled={!saveEnabled}
              loading={isSaving}
              className={cn("rounded-[8px] bg-[linear-gradient(180deg,#788AF7_0%,#3551F3_100%)]", wide ? "px-8" : "flex-1")}
            >
              Save
            </ButtonV2>
          </div>
        </div>
      </div>
    </div>
  );
};